import { render, staticRenderFns } from "./CreditMessage.vue?vue&type=template&id=16e586a8"
import script from "./CreditMessage.vue?vue&type=script&lang=js"
export * from "./CreditMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports